//libs
import { styled } from '@nykaa/ui-components';

//helpers
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

//components
import BaseDots from 'shared/components/Dots';
import ImageV2 from 'shared/components/ImageV2';
import ButtonBase from '@nykaa/ui-components/Button';

//constants
import { BUTTON } from './constants';

export const Image = styled(ImageV2)<{
  stackTop: boolean;
}>`
  position: absolute;
  height: auto;
  width: 100%;
  left: 0;
  top: 0;
  z-index: ${({ stackTop }) => (stackTop ? 0 : -1)};
`;

export const ArrowButtons = styled.div`
  display: none;
  position: absolute;
  top: 50%;
  width: 100%;
  justify-content: space-between;
`;

export const ArrowIconButton = styled(ButtonBase)<{ buttonType: BUTTON }>`
  position: absolute;
  padding: 6px;
  height: 32px;
  width: 32px;
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  rotate: ${({ buttonType }) => (buttonType === BUTTON.PREV ? `180deg` : `0deg`)};
  ${({ buttonType }) => (buttonType === BUTTON.PREV ? `left: 8px` : `right: 8px`)};
`;

export const Dots = styled(BaseDots)`
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
  margin-left: 0;

  & .dots > * {
    background-color: ${({ theme }) => theme.colors.surface50};
  }
  & .dots .active {
    background-color: ${({ theme }) => theme.colors.surface};
  }
  & .dots:first-child {
    margin-left: ${({ theme }) => theme.spacing.spacing10};
  }
`;

export const DotsContainer = styled.div`
  position: absolute;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing10}`};
  bottom: 8px;
  right: 8px;
  background-color: ${({ theme }) => hexToRgb(theme.colors.surfaceInverse, 0.44)};
  border-radius: ${({ theme }) => theme.borders.radius20};
  display: flex;
  align-items: center;
  display: none;
`;
